import { lazy, Suspense, useState, useSyncExternalStore } from "react";
import { settingsStore, useKeyboardShortcuts } from "@jkast90/kast-common/ui";

// The settings dialog is its own chunk, loaded the first time it opens.
const SettingsDialog = lazy(
  () => import("@settings/components/SettingsDialog"),
);

/**
 * homepage's settings dialog, shown by kast-common's settings store: the
 * gear on the profile page (and Shift+S) opens it. Mounted once in the app.
 * Once opened, it stays mounted (as it always was).
 */
export default function HomeSettings() {
  const open = useSyncExternalStore(
    settingsStore.subscribe,
    settingsStore.getSnapshot,
    settingsStore.getSnapshot,
  );
  const [wanted, setWanted] = useState(false);
  // Opened once: from then on it stays mounted.
  if (open && !wanted) setWanted(true);

  // Shift+S: Settings (not while typing)
  useKeyboardShortcuts({ "shift+s": () => settingsStore.open() });

  return wanted ? (
    <Suspense fallback={null}>
      <SettingsDialog />
    </Suspense>
  ) : null;
}
